module.exports = __webpack_public_path__ + "static/media/RQ1.cc48cfb6.pdf";